import { z } from "zod";
export const USER_ROLES = ["owner", "tenant"];
export const userRoleSchema = z.enum(USER_ROLES);
export const UserRoleEnum = {
    OWNER: "owner",
    TENANT: "tenant",
};
